import axios from 'axios';
import { buildApiV2Url, jsonApiFieldList } from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';
import { mapSurveyListItemFromApiModel } from '../dataMapper/surveyListItemDataMapper';
import { SURVEY_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

const knownErrorsMap = {
  LandingPageOrEmailRequired:
    'Post survey logic configured but Landing page is turned off or Email address is not required',
  CutOffDateIsOutOfRange:
    'This survey cannot be opened. Please modify survey cut-off date in the settings',
  LandingPageIsEmpty: 'Thank you page is empty',
  QuestionsPageIsEmpty: 'Question page is empty',
  EndPageIsEmpty: 'Landing page is empty',
  MultiEmptyPages:
    'Before we can open your survey please improve your empty pages or delete them.',
  SingleEmptyPage:
    'Before we can open your survey please improve your empty page or delete it.',
};

export default (entityId, { status }) =>
  axios
    .patch(
      buildApiV2Url(
        `${SURVEY_TYPE_COLLECTION_PATH}/${entityId}`,
        jsonApiFieldList.surveyListItem,
      ),
      { status },
    )
    .catch(generateApiError({ knownErrorsMap }))
    .then(response => mapSurveyListItemFromApiModel(response.data));
